module.exports = __webpack_public_path__ + "img/05_feet_Isonoe_silver.a31ddf29.png";